import { useRef } from 'react'
import { useQuery } from 'react-query'
import { captureUTM } from '../apiModules/captureUtm'

export const useCaptureUTM = urlParams => {
  const disabled = useRef(false)

  useQuery(
    ['captureUtm'],
    () => {
      captureUTM(urlParams)
    },
    {
      onSuccess: () => {
        disabled.current = true
      },
      staleTime: Infinity,
      cacheTime: Infinity,
      disabled: disabled.current,
    },
  )
}
